module.exports = __webpack_public_path__ + "img/subcurve1.34cd82b7.svg";